import React from 'react';
import './HowToUse.css';

const HowToUse = () => {
  return (
    <div className="how-landing-container">
      {/* Hero Section */}
      <section className="hero">
        <h1 className="hero-title">How to Use PositionPrep</h1>
        <p className="hero-subtitle">
          PositionPrep simplifies job applications by generating tailored cover letters and interview questions in seconds.
        </p>
      </section>

      {/* Cover Letter Section */}
      <section className="how-it-works">
        <h2 className="section-title">Cover Letter Generator</h2>
        <p className="explanation">Using PositionPrep significantly improves your job application results by allowing you to apply for multiple jobs quickly while maintaining high-quality, tailored cover letters. This increases your chances of securing interviews and landing your ideal job.</p>
        <div className="steps-container">
          <div className="step">
            <h3>1. Copy the Job Description</h3>
            <p>Copy the position description (PD) or job listing details.</p>
          </div>
          <div className="step">
            <h3>2. Paste into PositionPrep</h3>
            <p>Input the job description into the Cover Letter Generator.</p>
          </div>
          <div className="step">
            <h3>3. Generate Your Cover Letter</h3>
            <p>PositionPrep will craft a personalized and professional cover letter.</p>
          </div>
          <div className="step">
            <h3>4. Paste & Submit</h3>
            <p>Copy the generated cover letter and paste it into Quick Apply or Easy Apply.</p>
          </div>
        </div>
      </section>

      {/* Interview Questions Section */}
      <section className="how-it-works">
        <h2 className="section-title">Interview Question Generator</h2>
        <p className="explanation">PositionPrep’s Interview Question Generator helps you prepare effectively by providing tailored questions that match the job description. Practicing with these questions enables you to give confident and well-structured responses, increasing your chances of making a strong impression in interviews.</p>
        <div className="steps-container">
          <div className="step">
            <h3>1. Paste the Job Description</h3>
            <p>Input the job description into the Interview Question Generator.</p>
          </div>
          <div className="step">
            <h3>2. Receive Tailored Questions</h3>
            <p>Get customized interview questions based on the job description.</p>
          </div>
          <div className="step">
            <h3>3. Practice Your Responses</h3>
            <p>Prepare thoughtful and structured answers to boost interview confidence.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HowToUse;
